<template>
  <div>
    <div class="animated slideInRight m-3">
        <div class="" v-if="state.isDangerousGoods">
            <h3>This consignment contains dangerous goods</h3>
            <p>Book A Parcel does not support returns for dangerous goods.</p>
        </div>
        <div class="" v-if="!state.isDangerousGoods">
            <div class="row">
                <div class="col-md-6">
                    <h3>You</h3>
                    <table v-if="state.consignmentData" class="table table-bordered">
                        <tr v-for="(m, index) in meta" :key="index">
                            <th>{{ m.label }}</th>
                            <td>{{ state.consignmentData['sender'+m.key] }}</td>
                        </tr>
                    </table>
                </div>
                <div class="col-md-6">
                    <h3>Receiver</h3>
                    <table v-if="state.consignmentData" class="table table-bordered">
                        <tr v-for="(m, index) in meta" :key="index">
                            <th>{{ m.label }}</th>
                            <td>{{ state.consignmentData['receiver'+m.key] }}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="row" v-if="!state.isDangerousGoods">
                <div class="col">
                    <div class="form-group d-inline">
                        <p>Please confirm this information is correct. If it is not please contact the receiver.</p>
                    </div>
                    <button class="btn btn-primary float-right" data-toggle="modal" data-target="#confirmReviewModal">Continue</button>
                    <button class="btn btn-danger float-right mr-2" v-on:click="goToRoot">Cancel</button>
                </div>
            </div>
        </div>
      </div>
      <!-- Modal -->
      <div class="modal fade" id="confirmReviewModal" tabindex="-1" role="dialog" aria-labelledby="confirmReviewModal" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="confirmReviewLabel">Confirming Review</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p>I confirm this information is correct. If it is not please contact the receiver.</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
              <button type="button" class="btn btn-primary" @click="goToNextStep()" data-dismiss="modal">Confirm</button>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    import Step from '@/mixins/step'

    export default {
        mixins: [ Step ],
        name: 'StepReview',
        data () {
            return {
                meta: [
                    { key: '_name', label: 'Name' },
                    { key: '_contact', label: 'Contact' },
                    { key: '_email', label: 'Email' },
                    { key: '_phone', label: 'Phone' },
                    { key: '_address_1', label: 'Address Line One' },
                    { key: '_address_2', label: 'Address Line Two' },
                    { key: '_town', label: 'Town' },
                    { key: '_postcode', label: 'Postcode' },
                    { key: '_state', label: 'State' }
                ]
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>
